export default __webpack_public_path__ + "static/media/1841.be9b9cbc.png";